import React from 'react'

import { Container, Paper, Typography } from '@mui/material'
import Grid2 from '@mui/material/Unstable_Grid2' // Grid version 2
import PageFooter from '../components/PageFooter.js'
import { ThemeProvider } from '@mui/system'
import theme from '../styles/theme/'
// import { appUtilities, emale } from '../utilities/appUtilities.js'

export default function CheckoutSuccess() {
    const companyNameTM = ` ElectroBraid Fence`
    // const e = emale()

    return (
        <>
            <ThemeProvider theme={theme}>
                <Container
                    maxWidth="md"
                    sx={{
                        marginTop: { xs: 4, md: 8 },
                    }}
                >
                    <Paper elevation={8} sx={{ mb: 3 }}>
                        <Grid2 container spacing={2}>
                            <Grid2 xs={12} sx={{ mt: 3 }}>
                                <Typography align="center" variant="h6">
                                    Thank you for your order
                                </Typography>
                            </Grid2>

                            <Grid2
                                xs={12}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    align="center"
                                    sx={{ mt: 4 }}
                                >
                                    {
                                        'We appreciate your business. If you have any questions concerning your order'
                                    }
                                </Typography>
                                <Typography
                                    variant="subtitle1"
                                    align="center"
                                    sx={{ mt: 1 }}
                                >
                                    {
                                        ' please call 1 855 EB FENCE or 1 855 323 3623'
                                    }
                                </Typography>
                            </Grid2>

                            {/* <Grid2
                                xs={12}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <Button
                                    variant="contained"
                                    target="_top"
                                    rel="noopener noreferrer"
                                    href={`mailto:${e}`}
                                    color="primary"
                                    sx={{ mt: 2 }}
                                >
                                    <Typography
                                        variant="button"
                                        style={{ fontSize: '0.7rem' }}
                                    >
                                        {e}
                                    </Typography>
                                </Button>
                            </Grid2> */}

                            <Grid2 xs={12} sx={{ mt: 4, mb: 5, mx: 6 }}>
                                <Typography variant="subtitle1" align="center">
                                    {`Thank you for choosing ${companyNameTM}, America's #1
                                Electric Horse Fence.`}
                                </Typography>
                            </Grid2>
                        </Grid2>
                    </Paper>
                    <PageFooter />
                </Container>
            </ThemeProvider>
        </>
    )
}
